import { render, staticRenderFns } from "./CargoSelect.vue?vue&type=template&id=454f3056&scoped=true"
import script from "./CargoSelect.vue?vue&type=script&lang=js"
export * from "./CargoSelect.vue?vue&type=script&lang=js"
import style0 from "./CargoSelect.vue?vue&type=style&index=0&id=454f3056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f3056",
  null
  
)

export default component.exports